export const isAnyKeyFromSearchExistInSource = (source: string[], search: string[]) => {
    for (let i = 0; i < search.length; i++) {
        if (source.find(v => v == search[i])) {
            return true;
        }
    }
    return false;
}